import { useHeaderHeight } from '@react-navigation/elements'
import { FC, ReactNode } from 'react'
import { KeyboardAvoidingView } from 'react-native'

interface AuthHeaderKeyboardAvoidingViewProps {
    children: ReactNode
}

const AuthHeaderKeyboardAvoidingView: FC<AuthHeaderKeyboardAvoidingViewProps> = ({ children }) => {
    const headerHeight = useHeaderHeight()

    return (
        <KeyboardAvoidingView
            behavior="position"
            keyboardVerticalOffset={headerHeight}
            contentContainerStyle={{ alignItems: 'center' }}
            style={{ alignItems: 'center' }}
        >
            {children}
        </KeyboardAvoidingView>
    )
}

export default AuthHeaderKeyboardAvoidingView
